import { render, staticRenderFns } from "./pos-wipay-payment-modal.vue?vue&type=template&id=899c0852&scoped=true&"
import script from "./pos-wipay-payment-modal.vue?vue&type=script&lang=ts&"
export * from "./pos-wipay-payment-modal.vue?vue&type=script&lang=ts&"
import style0 from "./pos-wipay-payment-modal.vue?vue&type=style&index=0&id=899c0852&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "899c0852",
  null
  
)

export default component.exports